var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageRequestPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1036.362)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path828",
    transform: "translate(0 1036.362)",
    d: "M8 1a7 7 0 0 0-7 7 7 7 0 0 0 7 7 7 7 0 0 0 7-7 7 7 0 0 0-7-7zm0 1a6 6 0 0 1 6 6 6 6 0 0 1-6 6 6 6 0 0 1-6-6 6 6 0 0 1 6-6z",
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#373737",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 3.20000005,
      strokeOpacity: 0.55063291
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect891",
    d: "m6 1041.362 5 3-5 3z",
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#373737",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 3.20000005,
      strokeOpacity: 0.55063291
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageRequestPlay);
export default __webpack_public_path__ + "static/media/message-request-play.1008deb09e3338f82ec702de52e6a105.svg";
export { ForwardRef as ReactComponent };